export default "/_next/static/images/6-2a65975a86467dcb7a941c74fe83c97a.png";